import posthog from 'posthog-js'

// Define types for Clerk on the window object
declare global {
  interface Window {
    Clerk?: {
      user?: {
        id: string;
        fullName?: string;
        primaryEmailAddress?: {
          emailAddress: string;
        };
      };
    };
  }
}

const isBrowser = typeof window !== 'undefined'
const apiKey = import.meta.env.VITE_POSTHOG_API_KEY
const apiHost = import.meta.env.VITE_POSTHOG_HOST || 'https://app.posthog.com'

if (isBrowser && apiKey && window.location.hostname !== 'localhost') {
  try {
    posthog.init(apiKey, {
      api_host: apiHost,
      disable_session_recording: false,
      loaded: (posthog) => {
        if (process.env.NODE_ENV === 'development') posthog.debug()
      },
      capture_pageview: true,
      capture_pageleave: true,
      autocapture: true,
      persistence: 'localStorage',
      opt_out_capturing_by_default: false,
      session_recording: {
        maskAllInputs: true,
        maskTextSelector: 'input[type="password"]',
        blockClass: 'ph-no-capture',
        maskInputOptions: {
          password: true,
          email: true,
          number: false,
          textarea: false
        }
      }
    })

    setTimeout(() => {
      if (isBrowser && window.Clerk && window.Clerk.user) {
        try {
          const user = window.Clerk.user;
          posthog.identify(user.id, {
            email: user.primaryEmailAddress?.emailAddress,
            name: user.fullName,
          });
        } catch (error) {
          console.error('Error identifying user:', error);
        }
      }
    }, 2000);

    posthog.capture('posthog_initialized', { success: true })
    console.log('PostHog initialized successfully')
  } catch (error) {
    console.error('Failed to initialize PostHog:', error)
  }
} else {
  console.warn(
    'PostHog not initialized: ' +
    (!apiKey ? 'API key missing' : 'Not enabled for this environment')
  )
}

export const identifyUser = (userId: string, userProperties: any = {}) => {
  if (posthog) {
    posthog.identify(userId, userProperties);
  }
};

export default posthog 